import { observer } from 'mobx-react-lite'
import { CombineScreen } from 'page/CombineScreen'
import { ComboScreen } from 'page/ComboScreen'
import { ErrorPage } from 'page/ErrorPage'
import { ExistingScreen } from 'page/ExistingScreen/ExistingScreen'
import { GeneratingScreen } from 'page/GeneratingScreen/GeneratingScreen'
import { GenerationsScreen } from 'page/GenerationsScreen/GenerationsScreen'
import { InferenceScreen } from 'page/InferenceScreen/InferenceScreen'
import { LoadingPage } from 'page/LoadingPage'
import { MaxiBasic } from 'page/MaxiBasic'
import { Policy } from 'page/Policy/Policy'
import { ProfilePages } from 'page/ProfileScreen/ProfilePages'
import { FullbodyScreen } from 'page/FullbodyScreen/FullbodyScreen'
import { SelfieScreen } from 'page/SelfieScreen/SelfieScreen'
import { StandInferenceScreen } from 'page/StandInferenceScreen/StandInferenceScreen'
import { StandProfilePage } from 'page/StandProfilePage/StandProfilePage'
import { StartScreen } from 'page/StartScreen/StartScreen'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const Maxi = observer(() => {
  if (store.error) return <ErrorPage />
  if (!store.ready) return <LoadingPage />

  if (opt.basic) return <MaxiBasic />

  switch (store.screen) {
    case 'selfie':
      return <SelfieScreen />
    case 'fullbody':
      return <FullbodyScreen />
    case 'policy':
      return <Policy />
    case 'start':
      return <StartScreen />
    case 'start_combo':
      return <ComboScreen />
    case 'combine_select':
      return <CombineScreen />
    case 'profile':
      return opt.stand2 ? <StandProfilePage /> : <ProfilePages />
    case 'generating':
      return <GeneratingScreen />
    case 'existing':
      return <ExistingScreen />
    case 'image':
      return opt.stand2 ? <StandInferenceScreen /> : <InferenceScreen />
    case 'generations':
      return <GenerationsScreen />
    default:
      return undefined
  }
})
